function isBildMatchLive(match_date, match_time, finished) {
    if (finished === "yes") return false;

    // Germany timezone
    const timeZone = "Europe/Berlin";

    // Combine date and time into ISO string for Berlin TZ
    const matchDateTimeStr = `${match_date} ${match_time}`;

    // Parse as Berlin local time
    const matchStart = new Date(
        new Date(matchDateTimeStr + " GMT+0200").toLocaleString("en-US", { timeZone })
    );

    // End time = start + 95 minutes
    const matchEnd = new Date(matchStart.getTime() + 95 * 60 * 1000);

    const now = new Date();

    return now >= matchStart && now <= matchEnd;
}

module.exports = {
    isBildMatchLive
}